module.exports = __webpack_public_path__ + "static/img/22.0f1584b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/22.png
// module id = MdD9
// module chunks = 0